export const LAST_MODIFIED_FORMAT = 'yyyy-MM-dd\'T\'HH:mm:ss.SSSxxx';
export const ENEX_FORMAT = 'yyyyMMdd\'T\'HHmmssX';
export const IMPORTED_EVERNOTE_NOTEBOOK_TIME = 'dd LLL h:mma';
export const IMPORTED_MARKDOWN_NOTE_TIME = IMPORTED_EVERNOTE_NOTEBOOK_TIME;
